/* istanbul ignore file */
import React, { useContext } from 'react';
import { Menu, Text, Portal } from '@chakra-ui/react';
import { DataTableContext } from '..';
import { Check as CheckIcon } from 'react-feather';
import { BsGearFill } from 'react-icons/bs';

export const VisibleFieldsDropdown = () => {
  const { tableProps: props, setDataTableProps } = useContext(DataTableContext);
  const { styles, visibleKeys, displayKeyLabelMap, stickyLeftColumnKeys, stickyRightColumnKeys } = props;
  const setVisibleKeys = (keys: string[]) => {
    setDataTableProps({
      ...props,
      ...{ visibleKeys: keys },
    });
  };

  const getClickHandler = (key: string) => {
    if (!visibleKeys) {
      return () => setVisibleKeys([key]);
    }

    if (visibleKeys.includes(key)) {
      return () => removeKey(key);
    }
    return () => setVisibleKeys([...visibleKeys, key]);
  };

  const removeKey = (key: string) => {
    // Always force at least 1 visible key
    if (!visibleKeys || visibleKeys.length === 1) {
      return;
    }
    setVisibleKeys(visibleKeys.filter((k) => k !== key));
  };

  /* We need to create a portal popover as this is displayed within a sticky container */
  const popover = (
    <Menu.Positioner>
      <Menu.Content title="Display">
        {/* Remove keys (filter out) defined in the sticky columns as they are mandatory */}
        {Object.keys(displayKeyLabelMap)
          .filter((item) => !stickyLeftColumnKeys?.includes(item) && !stickyRightColumnKeys?.includes(item))
          .map((key) => (
            <Menu.Item
              display="flex"
              key={key}
              value={key}
              aria-label={visibleKeys?.includes(key) ? `Hide ${key} field` : `Show ${key} field`}
              onClick={getClickHandler(key)}
              css={styles?.tableMenuDropdownMenuItem}
            >
              {visibleKeys?.includes(key) ? <CheckIcon size={14} /> : <CheckIcon size={14} color={'transparent'} />}
              &nbsp;
              <Text flex={1} css={styles?.tableMenuDropdownMenuItemOption}>
                {displayKeyLabelMap[key]}
              </Text>
            </Menu.Item>
          ))}
      </Menu.Content>
    </Menu.Positioner>
  );

  return (
    <Text css={styles.tableMenuContainer}>
      <Menu.Root closeOnSelect={false}>
        <Menu.Trigger aria-label="Opens a menu to toggle which fields are rendered in the table">
          <BsGearFill cursor={'pointer'} size={12} color="var(--chakra-colors-icon-default)" />
        </Menu.Trigger>
        <Portal>{popover}</Portal>
      </Menu.Root>
    </Text>
  );
};
